import axios from "axios";
import { useEffect, useState } from "react";
//import { Link } from "react-router-dom";
import MenuPainelAdmin from '../partils/AdminMenuPainel'
import AdminItensFuncionario from '../partils/AdminItensListaFuncionario'

import React, { useRef } from 'react';
import { toPng } from 'html-to-image';



import { useNavigate } from 'react-router-dom';

import ChartPedidosMes from'../partils/ChartPedidosMes'
import ChartFormaPG from'../partils/ChartFormaPG'
import ChartProdutosMaisVendidos from '../partils/ChartProdutosMaisVendidos'
import ChartCampanhaInstagram from '../partils/ChartCampanhaInstagram'
import ChartReceitaMes from'../partils/ChartReceitaMes'

import ImgMoreData from'../../acets/img_icon/moredatadash.svg'

import AdminHeader from "../partils/AdminHeader";

export default function Painel(){
   const TenancyColorUser = localStorage.getItem('localcolorusers')
   const navigate = useNavigate();
   const tlocal = localStorage.getItem('keyItemNameg')
   axios.defaults.headers.common['token'] = tlocal;

   const initialvalues ={totalFaturamento:0,valor_baixa:0,countOrcamento:'0',produto:'0',servico:'0',totalpivoorcaprod:'0',totalcusto:'0',totalclientefornecedoroficina:'0',repasserealizado:'0'}

   const [produto,setProduto]=useState(0)
   const [orcamento,setOrcamento]=useState(0)
   const [feedback,setFeedback]=useState(0)
   const [faturamento,setFaturamento]=useState(0)
   const [data,setData]=useState()
   const [checkout,setCheckout]=useState([])
   const [fatTotal,setFatTotal]=useState(0)
   const [values,setValues]=useState({initialvalues})
   const [showfilters, setShowfilters]=useState(false)
   const [showDataNunber,setShowDataNunber]=useState(false)
   const [opemrelatorio,setOpemrelatoeio]=useState(false)

   const [dataCliente,setDataCliente]=useState([])
   const [dataProdutos,setDataProdutos]=useState([])

   const [dataformapg,setDataformapg]=useState([])
   const [datadevedor,setDatadevedor]=useState([])

   // Obter a data de hoje no formato 'YYYY-MM-DD'
   const today = new Date();
   const year = today.getFullYear();
   const month = String(today.getMonth() + 1).padStart(2, '0'); // Adiciona zero à esquerda, se necessário
   const day = String(today.getDate()).padStart(2, '0'); // Adiciona zero à esquerda, se necessário
   const formattedToday = `${year}-${month}-${Number(day) + 1}`;

   
   const [intervalfinalDate, setIntervalfinalDate] = useState(formattedToday);
   const [intervalinitialDate,setIntervalinitialDate]=useState('2024-02-01')
   const[opemprodutosucess,setOpemprodutosucess]=useState(true)
   const divRef = useRef();//converter div para imagem

   const tenancylocal = localStorage.getItem('ClienteTenancy')

   useEffect(()=>{
      rec();
      // eslint-disable-next-line react-hooks/exhaustive-deps
      },[])
      function rec() {//CARREGAR ESTADOS E ATUALIZAR CICLO DE COMPONENTES 
         axios.get('/api/empresa/tenancy/one/' + tenancylocal)
            .then(resp => {
              const invalid = {ERRO: 'token invalido 3'};
                if (JSON.stringify(resp.data[0]) === JSON.stringify(invalid)) {
                  navigate('/login');
                  window.location.reload(true);
                }
                else{
                  setData(resp.data);
                }
            })
            .catch(error => {
              console.log(error);
              return <div>{error.message || error.toString()}</div>; // renderiza a mensagem de erro como uma string
            })
            .catch(err => console.log(err));

            axios.get(`/api/dashboard/orcamento/conttotal/${intervalinitialDate}/${intervalfinalDate}`)
            .then(resp => {
               //console.log(resp.data.total)
                setValues(prevValues => ({
                    ...prevValues,
                    totalFaturamento: resp.data.total
                }));
            })
            axios.get(`/api/dashboard/orcamento/cont/${intervalinitialDate}/${intervalfinalDate}`)
            .then(resp => {
               //console.log(resp.data)
                setValues(prevValues => ({
                    ...prevValues,
                    countOrcamento: resp.data
                }));
            })
            axios.get(`/api/dashboard/pivo/baixaorcamento/${intervalinitialDate}/${intervalfinalDate}`)
            .then(resp => {
               //console.log(resp.data.valor_baixa)
                setValues(prevValues => ({
                    ...prevValues,
                    valor_baixa: resp.data.valor_baixa
                }));
            })
            
            axios.get(`/api/dashboard/pivo/baixaorcamentotipo/${intervalinitialDate}/${intervalfinalDate}`)
            .then(resp => {
               //console.log(resp.data)
               setDataformapg(resp.data)
            })
            axios.get(`/api/dashboard/produto/count/${intervalinitialDate}/${intervalfinalDate}`)
            .then(resp => {
               //console.log(resp.data)
                setValues(prevValues => ({
                    ...prevValues,
                    produto: resp.data
                }));
            })
            axios.get(`/api/dashboard/servico/count/${intervalinitialDate}/${intervalfinalDate}`)
            .then(resp => {
               //console.log(resp.data)
                setValues(prevValues => ({
                    ...prevValues,
                    servico: resp.data
                }));
            })
            axios.get(`/api/dashboard/pivoorcaprod/counttotal/${intervalinitialDate}/${intervalfinalDate}`)
            .then(resp => {
               //console.log(resp.data.preco)
                setValues(prevValues => ({
                    ...prevValues,
                    totalpivoorcaprod: resp.data.preco
                }));
            })
            //oficina
            axios.get(`/api/dashboard/pivoorcaprod/counttotal/oficina/${intervalinitialDate}/${intervalfinalDate}`)
            .then(resp => {
               //console.log(resp.data)
                setValues(prevValues => ({
                    ...prevValues,
                    totalclientefornecedoroficina: resp.data.preco
                }));
            })
            


            axios.get(`/api/dashboard/custo/conttotal/${intervalinitialDate}/${intervalfinalDate}`)
            .then(resp => {
                setValues(prevValues => ({
                    ...prevValues,
                    totalcusto: resp.data.valor
                }));
            })
           {/* axios.get(`/api/clientefornecedor/3`)
            .then(resp => {
               //console.log(resp.data)
                setValues(prevValues => ({
                    ...prevValues,
                    totalclientefornecedoroficina: resp.data[0].saldo
                }));
            })
         */}
            axios.get(`/api/orcamento/${intervalinitialDate}/${intervalfinalDate}`)
            .then(resp =>{
               //console.log(resp.data)
               setOrcamento(resp.data)
            }) 
            axios.get(`/api/dashboard/pivo/baixaclientefornecedor/${intervalinitialDate}/${intervalfinalDate}`)
            .then(resp =>{
               //console.log(resp.data.valor_baixa)
               setValues(prevValues => ({
                  ...prevValues,
                  repasserealizado: resp.data.valor_baixa
              }));
            }) 
            axios.get(`/api/dashboard/orcamento/faltantes`)
            .then(resp =>{
               //console.log(resp.data)
               setDatadevedor(resp.data)
            })

            axios.get('/api/clientefuncionario/').then(resp=>{
               setDataCliente(resp.data)
               console.log(dataCliente)
            })
     }
    //console.log(dataCliente)
    const handleDownloadImage = () => {
            if (divRef.current === null) {
              return;
            }
        
            toPng(divRef.current)
              .then((dataUrl) => {
                const link = document.createElement('a');
                link.href = dataUrl;
                link.download = 'relatorio.png'; // Nome do arquivo
                link.click();
              })
              .catch((err) => {
                console.log(err);
              });
          };


    const FuncionariosSevicos = dataCliente.map(repsValues => (
      <div className="w100 h5 linham2 row between">
         <label>{repsValues.cliente.nome}</label>

         <AdminItensFuncionario id={repsValues.id_clientefuncionario} dtini={intervalinitialDate} dtfim={intervalfinalDate}/>
        
      </div>

    ));
    
    const totalGanho = fatTotal&&fatTotal.reduce((acc, item) => {
     return acc + item.produto.preco_final;
    }, 0);
  
    const valorTotal = values.totalFaturamento;
    const valorParcial = values.valor_baixa-(values.totalFaturamento-values.totalclientefornecedoroficina)-values.totalcusto;
    
    const porcentagem = (valorParcial / valorTotal) * 100;
    
    //console.log(datadevedor)
    
   const rendermapdevedores = datadevedor.map(resp=>
      <div className="list-row" key={resp.id_orcamento_venda}>
         <div className="df aic g2 f1" style={{minWidth:0}}>
            <div className="avatar" style={{backgroundColor:TenancyColorUser||'#8B5CF6'}}>
               {resp.cliente.nome.toLowerCase() === 'prefeitura' ? 'P' : resp.cliente.nome.split(' ').map(p => p[0]).slice(0, 2).join('').toUpperCase()}
            </div>
            <div className="dfc" style={{minWidth:0}}>
               <label className="tx-sm fb2 c-dark ell">{resp.cliente.nome}</label>
               <label className="tx-xs c-gray">{new Date(resp.createdAt).toLocaleDateString('pt-BR')}</label>
            </div>
         </div>
         <label className="tx-sm fb3 c-dark">R$ {resp.valor_falta}</label>
         <div
            className="chip pp"
            style={{backgroundColor:TenancyColorUser||'#16C784', color:'#fff'}}
            onClick={() => {
               if (resp.cliente.telefone) {
                  const message = `Olá, percebemos que o orçamento de código ${resp.id_orcamento_venda} está com o valor de R$: ${resp.valor_falta} em aberto. Realize o pagamento e volte a ficar adimplente. para ter acesso ao orçamento digite "orçamento" na conversa do WhatsApp.     Visite o nosso site https://www.autometricas.com.br`;
                  const url = `https://wa.me/${resp.cliente.telefone}?text=${encodeURIComponent(message)}`;
                  window.open(url, '_blank');
               } else {
                  alert('Número de telefone não disponível.');
               }
            }}
            >
            Cobrar
         </div>
      </div>
   )

   

   function Dashboard(){
         const areceber = values.totalFaturamento-values.valor_baixa;
         const cardsExtras = [
            {titulo:'Custos', valor:values.totalcusto, icon:'💡', cor:'orange', title:'Custos com despesas como aluguel, salarios, conta de luz, agua internet etc...'},
            {titulo:'Fornecedor', valor:(values.totalFaturamento-values.totalclientefornecedoroficina).toFixed(2), icon:'🚚', cor:'purple', title:'Soma de todos os produtos presentes nos orçamentos em que o fornecedor não é a oficina.'},
            {titulo:'Serviços', valor:values.totalclientefornecedoroficina, icon:'🔧', cor:'blue', title:'Mão de obra Total, incluindo os recebidos e os a receber'},
            {titulo:'Lucro Bruto', valor:(values.totalFaturamento - values.totalcusto - (values.totalFaturamento - values.totalclientefornecedoroficina)).toFixed(2), icon:'📈', cor:'green', title:'Faturamento - custos - fornecedores'},
            {titulo:'Lucro recebido', valor:values.valor_baixa-(values.totalFaturamento-values.totalclientefornecedoroficina), icon:'💰', cor:'green', title:'Recebido - fornecedores'},
            {titulo:'Lucro L. rcb', valor:(values.valor_baixa-(values.totalFaturamento-values.totalclientefornecedoroficina)-values.totalcusto).toFixed(2), icon:'✅', cor:'green', title:'Recebido - fornecedores - custos'},
            {titulo:'Repasse Rlzdo.', valor:values.repasserealizado, icon:'📤', cor:'blue', title:'Transferencias realizadas aos fornecedores'},
            {titulo:'Repasse Pend.', valor:((values.totalFaturamento-values.totalclientefornecedoroficina)-values.repasserealizado).toFixed(2), icon:'⏳', cor:'red', title:'Transferencias pendentes aos fornecedores'},
         ];
         return(
            <div className="w100 dfc g3 mt3">
               <div className="grid grid-stats g3">
                  <div className="card stat-card hover-card dfc g2" title="Quantidade de orçamentos na data">
                     <div className="icon-box icon-purple">📋</div>
                     <label className="tx-sm c-gray fb2">Orçamentos</label>
                     <label className="tx-xl fb3 c-dark">{values.countOrcamento}</label>
                  </div>

                  <div className="card stat-card hover-card dfc g2" title="Tudo o dinheiro que entrou na empresa">
                     <div className="icon-box icon-green">💲</div>
                     <label className="tx-sm c-gray fb2">Faturamento</label>
                     <label className={`tx-xl fb3 ${values.totalFaturamento == values.totalpivoorcaprod ? 'c-dark' : 'down'}`}>R$ {values.totalFaturamento}</label>
                     {values.totalFaturamento != values.totalpivoorcaprod &&
                        <label className="tx-xs c-gray">{values.totalpivoorcaprod} pro.adds</label>}
                  </div>

                  <div className="card stat-card hover-card dfc g2" title="Baixas nos orcamento, soma dos recebidos">
                     <div className="icon-box icon-blue">👛</div>
                     <label className="tx-sm c-gray fb2">Recebido</label>
                     <label className="tx-xl fb3 c-dark">R$ {values.valor_baixa}</label>
                  </div>

                  <div className="card stat-card hover-card dfc g2" title="Soma do que ficou fiado nos orçamentos">
                     <div className="icon-box icon-orange">⏰</div>
                     <label className="tx-sm c-gray fb2">A receber</label>
                     <label className="tx-xl fb3 c-dark">R$ {areceber}</label>
                  </div>

                  <div className="card stat-card hover-card dfc g2 jcb pp" onClick={()=>setShowDataNunber(!showDataNunber)}>
                     <div className="icon-box icon-red" style={{color:TenancyColorUser}}>✚</div>
                     <label className="tx-sm c-gray fb2" >Mais dados</label>
                     <label className="tx-xs fb2 pp" style={{color:TenancyColorUser}}>
                        {showDataNunber ? 'Minimizar' : 'Personalize seus indicadores'}
                     </label>
                  </div>
               </div>

               {showDataNunber &&
                  <div className="grid grid-stats g3">
                     {cardsExtras.map((c,i)=>(
                        <div className="card stat-card hover-card dfc g2" key={i} title={c.title}>
                           <div className={`icon-box icon-${c.cor}`}>{c.icon}</div>
                           <label className="tx-sm c-gray fb2">{c.titulo}</label>
                           <label className="tx-lg fb3 c-dark">R$ {c.valor}</label>
                        </div>
                     ))}
                  </div>
               }
            </div>
         )
      }
      const finalprodutos = dataProdutos.map(respstring=>
         <div className="row between linha" key={respstring.id_pivo_orcamento_produto}>
            <label className="fs09em w15">{new Date(respstring.createdAt).toLocaleDateString("pt-BR")}</label>
            <label className="fs09em w5">{respstring.quantidade}</label>
            <label className="fs09em w60">{respstring.produto_servico.descricao}</label>
            <label  style={{
                    background: `${
                     respstring.orcamento.status ===1
                        ? "#68A652"
                        : respstring.orcamento.status ===2
                        ? "#FFEC87"
                        : respstring.orcamento.status ===3
                        ? "#B1FF95"
                        : respstring.orcamento.status ===4
                        ? "#FFA487"
                        : "transparent"
                    }`,
                    width:'10%',
                    fontSize:'0.8em',
                    textAlign:'center'
                }}>{
                    
                  respstring.orcamento.status === 1
                ? "Em Serv."
                : respstring.orcamento.status === 2
                ? "Pg Pend"
                : respstring.orcamento.status === 3
                ? "Pago"
                : respstring.orcamento.status === 4
                ? "Cancelado"
                : null
                }</label>
              
            <label className="fs09em w10">R$: {respstring.preco*respstring.quantidade}</label>
         </div>
      )
      function listarprodutos(){
         axios.get(`/api/dashboard/pivoorcaprod/contprodutosvendidos/${intervalinitialDate}/${intervalfinalDate}`).then(resp=>{
            setDataProdutos(resp.data)
            console.log(resp.data)
            setOpemprodutosucess(false)
          })
      }
      const totalProdutos = dataProdutos.reduce((total, item) => total + item.quantidade * item.preco, 0);
      const totalRecebido = dataProdutos
    .filter(item => item.orcamento.status === 3)
    .reduce((total, item) => total + item.quantidade * item.preco, 0);
     //style={{backgroundColor: TenancyColor().backgroundColor}}
    return(<>
      {opemrelatorio&&           
         <div className='w100 h700 posiabstop column center z17 top0' >
             <div className='w100 h700 posiabstop fundo-opaco z5 pcb10 top0' onClick={()=>(setOpemrelatoeio(false))}>
             </div>
             <div className='h20 w70 b2 z5 cont-circ3 sombra column center z10 cell-tamanho90 pcb10 ' ref={divRef}>
                 <div className='w65 h20'>
                     <div className='w100 cen'>
                        <label>{new Date().toLocaleDateString("pt-BR")}</label>
                     </div>
                     <h5 className="w100 cen fs2em pcb50">{tenancylocal}</h5>
                     <h5 className="fb pcb50">
                        Relatório Financeiro - {"De: " + new Date(intervalinitialDate).toLocaleDateString("pt-BR") + 
                        " até " + new Date(intervalfinalDate).toLocaleDateString("pt-BR")}
                     </h5>
                     <h5 className="fb">Introdução</h5>
                     <label>
                     Este relatório apresenta um balanço financeiro da oficina referente à data supracitada. Com uma abordagem técnica e objetiva, ele destaca o faturamento,
                     os custos operacionais e o lucro líquido, proporcionando uma visão clara do
                     desempenho financeiro do período. Essas informações auxiliam na tomada de decisões
                     </label>
                     <h5 className="fb">Desempenho Financeiro</h5>
                     <label>
                     Durante o período analisado, foram realizados <strong>{values.countOrcamento} </strong>orçamentos, resultando em um
                     faturamento total de R$:<strong>{values.totalFaturamento}</strong>. Deste valor, R$:<strong>{values.valor_baixa}</strong> já foram recebidos, enquanto R$:
                     <strong> {values.totalFaturamento-values.valor_baixa}</strong> ainda estão pendentes.
                     </label>
                     <h5 className="fb">Custos e Lucro</h5>
                     <label>
                     Os custos operacionais somaram R$:<strong>{values.totalcusto}</strong>, enquanto as despesas com peças de
                     fornecedores chegaram a R$:  <strong>{values.totalFaturamento-values.totalclientefornecedoroficina}</strong>. Os produtos e serviços prestados pela oficina geraram R$:
                     <strong>{values.totalclientefornecedoroficina}</strong>. Com isso, o lucro bruto da semana foi de R$:<strong>{values.totalFaturamento-values.totalcusto-(values.totalFaturamento-values.totalclientefornecedoroficina)}</strong>, porém, considerando os
                     valores já recebidos, o lucro líquido disponível ficou em R$: <strong>{values.valor_baixa-(values.totalFaturamento-values.totalclientefornecedoroficina)-values.totalcusto}</strong>.
                     </label>
                     <h5 className="fb">Repasse para Fornecedores</h5>
                     <label>
                        Até o momento, {values.repasserealizado ? (
                           <>foi realizado o total de R$ {values.repasserealizado}</>
                        ) : (
                           <>nenhum repasse foi realizado às autopeças,</>
                        )}{" "}
                        mas há um saldo pendente de R${" "}
                        <strong>
                           {values.totalFaturamento - values.totalclientefornecedoroficina - values.repasserealizado}
                        </strong>{" "}
                        a ser quitado.
                     </label>

                     <h5 className="fb">Conclusão</h5>
                     <label>
                     Os números demonstram um bom volume de serviços e um faturamento consistente,
                     mas a alta pendência financeira exige atenção para garantir o equilíbrio do fluxo de
                     caixa. A regularização dos repasses ajudará a manter boas relações com fornecedores e
                     a sustentabilidade da oficina.Esse relatório possui um dashboard focado em peças e serviços
                     e no fim da página uma tabela focada apenas em serviços.
                     </label>
                     <Dashboard/>
                     <div className="w100 row between pcb50">
                        <h5 className="fb">Mão de obra de cada funcionário:</h5>
                     </div>
                     <label>Para um funcionário que recebe R$ 2000/mês, considerando encargos e uma margem de lucro de 20%, ele precisa faturar no minimo R$ 4250/mês para ser rentável. Referência: Cálculo baseado em encargos trabalhistas e margem de lucro empresarial - Associação brasileira de pequenas e médias empresas.</label>
                     <div className="w100 pcb50">
                        {FuncionariosSevicos}
                     </div>
                     



                     <h5 className="fb">Produtos vendidos da oficina:</h5>
                     <div className="w100">
                        <div className="pcb10">
                           <label className="w100">Listagem somente de Produtos da oficina vendidos no periodo, desconsiderando o custo de cada produto. desta forma o total não representa o lucro. e sim o faturamento apenas.</label>
                        </div>
                        
                        {opemprodutosucess && <button onClick={()=>listarprodutos()}>Listar produtos</button>}
                        {finalprodutos}
                        <div className='pcb10 w100'> 
                           <label className='fb'>Balanço final da venda de peças da oficina:</label>
                        </div>
                        <h6 className='w100'>Total R$: {totalProdutos}</h6>
                        <h6 className='w100'>Recebido R$: {totalRecebido}</h6>
                        <h6 className='w100'>A receber:{totalProdutos-totalRecebido}</h6>
                     </div>
                    

                     <div className="pcb50 w100 column">
                        <h5 className="fb">Considerações finais</h5>
                        <label className="cen">
                        O presente relatório tem o objetivo de apoiar decisões estratégicas da empresa. Ele deve ser utilizado como um auxílio na análise de desempenho.
                        </label>
                     </div>
                     
                     <div className="pcb50 w100 column">
                        <label className="fb cen">Auto Métricas™</label>
                     </div>


                         
                         
                         
                     <div className='w100 row between'>
                         <label className='w40'>Sem mais opções</label>
                         <div className="row w60 between">
                           <button onClick={handleDownloadImage}>imprimir</button>
                           <button onClick={()=>(setOpemrelatoeio(false) )} className="w40 ma10b0 btn05">Cancelar</button>
                         </div>
                         
                     </div>
                     
                 </div>
             </div>
         </div>
     }
      <section className='h100 row between b31'>
         {//<AdminHeader props='Dashboard'/>
         }
         
         <MenuPainelAdmin/>
         <div className="h20 w80 row center celular cell-tamanho dash-wrap">
         <div className="w90 dfc g4 mt3">

                     <div className="df jcb aic fw g2">
                        <h5 className='tx-xl fb3 c-dark m0'>Dashboard</h5>
                        <button className="btn-outline" onClick={()=>setShowfilters(!showfilters)}>
                           {showfilters?'Fechar Filtros':'Abrir Filtros'}
                        </button>
                     </div>

                     {showfilters&&
                     <div className="w100 card p4 dfc g3">
                        <label className="tx-sm c-gray">Selecione o intervalo de datas para obter os dados</label>
                        <div className="df jcb fw g3">
                           <div className="dfc g1">
                              <label className="tx-xs c-gray">Início</label>
                              <input
                                 type="date"
                                 onChange={(e) => setIntervalinitialDate(e.target.value)}
                              />
                           </div>
                           <div className="dfc g1">
                              <label className="tx-xs c-gray">Fim</label>
                              <input
                                 type="date"
                                 onChange={(e) => setIntervalfinalDate(e.target.value)}
                              />
                           </div>
                           <div className="dfc g1 jcc">
                              <button className="btn-pri" style={{backgroundColor:TenancyColorUser}} onClick={()=>rec()}>Ir</button>
                           </div>
                           <div className="tx-xs c-gray dfc g1 jcc">
                              <label>{"De: "+intervalinitialDate + " até " + intervalfinalDate }</label>
                              <label className="fb2 pp" style={{color:TenancyColorUser}} onClick={()=>setOpemrelatoeio(!opemrelatorio)}>Gerar Relatório</label>
                           </div>
                        </div>
                     </div>
                     }

                     {//import aqui
                     <Dashboard />
                     }

                     <div className="w100 cont-circ15 b2 bordaElements">
                        {orcamento?
                           <ChartPedidosMes pedidos={orcamento} tipo={'Bar'} titulo={'Serviços/Vendas Fat.'} subtitulo={'Faturamento de servicos e vendas por mês'}  tipodado={2}/>:
                           <label className="tx-sm c-gray">Ops.. Sem dados no momento...</label>
                        }
                    </div>


                     <div className="grid grid-2 g3">
                        <div className="card p4 dfc g3">
                          
                              
                              <div className="f1 w100">
                              {orcamento&&
                                 <ChartFormaPG pg={dataformapg}/>
                              }
                              </div>
                           
                        </div>

                        <div className="card p4 dfc g2">
                           <h5 className="tx-lg fb3 c-dark m0">Automações</h5>
                           <div className="dfc" style={{maxHeight:'320px', overflowY:'auto'}}>
                              {rendermapdevedores}
                           </div>
                        </div>
                     </div>

                    <div className="w100 cont-circ15 b2 bordaElements">
                     {orcamento?
                        <ChartPedidosMes pedidos={orcamento} tipo={'Bar'} titulo={'Serviços/Vendas Qnt.'} subtitulo={'Quantidade de servicos e vendas por mês'} tipodado={1}/>:
                        <label className="tx-sm c-gray">Ops.. Sem dados no momento...</label>
                     }
                    </div>

                </div>

            </div>

      </section>
      </>)
}
//67982113560 itau
